import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Pipeline from "@/pages/Pipeline";
import Reports from "@/pages/Reports";
import Oportunidades from "@/pages/Oportunidades";
import Licitaciones from "@/pages/Licitaciones";
import PipelineLicitaciones from "@/pages/PipelineLicitaciones";
import Contactos from "@/pages/Contactos";
import Intel from "@/pages/Intel";
import RadarDolor from "@/pages/RadarDolor";
import EmpresaLicitadora from "@/pages/EmpresaLicitadora";
import InteligenciaHidrica from "@/pages/InteligenciaHidrica";
import MiTrabajo from "@/pages/MiTrabajo";
import Admin from "@/pages/Admin";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AlertProvider } from "@/context/AlertContext";
import { WellnessProvider } from "@/context/WellnessContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Protected Route — redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-cyan-400 animate-pulse">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout user={user}>
      {children}
    </Layout>
  );
};

// App Router
function AppRouter() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard user={user} /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Leads user={user} /></ProtectedRoute>} />
      <Route path="/contactos" element={<ProtectedRoute><Contactos user={user} /></ProtectedRoute>} />
      <Route path="/pipeline" element={<ProtectedRoute><Pipeline user={user} /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports user={user} /></ProtectedRoute>} />
      <Route path="/oportunidades" element={<ProtectedRoute><Oportunidades user={user} /></ProtectedRoute>} />
      <Route path="/licitaciones" element={<ProtectedRoute><Licitaciones user={user} /></ProtectedRoute>} />
      <Route path="/pipeline-licitaciones" element={<ProtectedRoute><PipelineLicitaciones user={user} /></ProtectedRoute>} />
      <Route path="/intel" element={<ProtectedRoute><Intel user={user} /></ProtectedRoute>} />
      <Route path="/radar-dolor" element={<ProtectedRoute><RadarDolor user={user} /></ProtectedRoute>} />
      <Route path="/radar-dolor/empresa/:nombre" element={<ProtectedRoute><EmpresaLicitadora user={user} /></ProtectedRoute>} />
      <Route path="/inteligencia-hidrica" element={<ProtectedRoute><InteligenciaHidrica user={user} /></ProtectedRoute>} />
      <Route path="/mi-trabajo" element={<ProtectedRoute><MiTrabajo user={user} /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin user={user} /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AlertProvider>
              <WellnessProvider>
                <AppRouter />
                <Toaster position="top-right" />
              </WellnessProvider>
            </AlertProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
